'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, cloneElement, forwardRef, isValidElement, } from 'react';
import * as Styles from './styles';
const HorizontalListDivider = ({ children, className, ...rest }) => (_jsx(Styles.Divider, { "aria-hidden": true, className: className, ...rest, children: children }));
const HorizontalListItem = forwardRef(({ children, className, ...rest }, ref) => {
    return (_jsx(Styles.ListItem, { className: className, ref: ref, ...rest, children: children }));
});
const HorizontalListWrapper = forwardRef(({ children, className, divider = _jsx(HorizontalListDivider, { children: "\u2022" }), ...rest }, ref) => {
    const childrenItems = Children.toArray(children);
    const createChildWithDivider = (child, index) => {
        if (isValidElement(child) && divider) {
            return cloneElement(child, {
                children: (_jsxs(_Fragment, { children: [child.props.children, index < childrenItems.length - 1 ? divider : null] })),
            });
        }
        return child;
    };
    return (_jsx(Styles.List, { className: className, ref: ref, ...rest, children: Children.map(childrenItems, createChildWithDivider) }));
});
export { HorizontalListWrapper as HorizontalList, HorizontalListItem, HorizontalListDivider };
//# sourceMappingURL=index.js.map